@if (showTable) {
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col
      columnType="string"
      name="label"
      [showFilter]="false"
      [showSort]="false"
      width="400px"
      i18n-displayName
    >
      <snelstart-ui-table-col-header>
        <div style="font-size: 13px; color: #00200b ">
          Aangifte
        </div>
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-expanded-row>
        <div *ngFor="let option of options; let i = index;">
          <div *ngFor="let subOnderdeel of option.subonderdelen!; let j = index;">
            <div *ngIf="subOnderdeel.visible">
              <snelstart-ui-button
                icon="chevron-right" type="link" class="ps-5"
                (click)="navigateToSubPage(subOnderdeel.pageMapping)">
                {{ subOnderdeel.label }}
              </snelstart-ui-button>

            </div>
          </div>
        </div>
      </snelstart-ui-table-expanded-row>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="onderdelenAanvullendeTekst"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            [decimals]="2"
                            i18n-displayName
                            width="250px">
      <snelstart-ui-table-col-header></snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <ng-container>

            <a *ngIf="record.value === 1">Dividenduitkeringen:</a>

            <b>
              <a *ngIf="record.value === 6">Te betalen:</a>
            </b>

          </ng-container>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="berekening"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            [decimals]="2"
                            i18n-displayName
                            width="250px"
    >
      <snelstart-ui-table-col-header>
        <div style="font-size: 13px; color: #00200b ">
          Totaal
        </div>
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <ng-container>
            <a *ngIf="record.value === 1">€ {{ this.totaalDividendUitkeringen.toLocaleString() }}</a>
            <b><a *ngIf="record.value === 6">€ {{ this.totaal.toLocaleString() }}</a></b>
          </ng-container>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

  </snelstart-ui-table>

  <snelstart-venture-fiscaal-domain-logic-service [(dialogVisible)]="this.dialogVisible"
                                                  [title]="'Nieuwe aangifte dividendbelasting aanmaken'"
  >
  </snelstart-venture-fiscaal-domain-logic-service>
}

